import { render } from "./MobileBottomMenu.vue?vue&type=template&id=f5d4710a&scoped=true"
import script from "./MobileBottomMenu.vue?vue&type=script&lang=js"
export * from "./MobileBottomMenu.vue?vue&type=script&lang=js"

import "./MobileBottomMenu.vue?vue&type=style&index=0&id=f5d4710a&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d4710a"]])

export default __exports__